import {Enumeration} from '../../../utils/AppEnum';
import {VirtualNetwork} from '../../entities/AzureResources/VirtualNetwork';
import { VirtualPrivateCloud } from '../../entities/AzureResources/VirtualPrivateCloud';
import {PortOpeningRequestsDirection} from './PortOpeningRequestsDirection';

export class RuleRegion extends Enumeration<RuleRegion> {

	constructor();
	constructor(name: string, value: number);
	constructor(name: string, value: number, porDirections: PortOpeningRequestsDirection[]);

	constructor(name?: string, value?: number, porDirections?: PortOpeningRequestsDirection[]) {
		super(name, value);
		this.porDirections = porDirections ?? [];
	}

	public porDirections: PortOpeningRequestsDirection[];

	public static America = new RuleRegion('America', 0);

	public static EAME = new RuleRegion('EAME', 1);

	public static AP = new RuleRegion('AP', 2);

	public static USSC = new RuleRegion('USSC', 3, new PortOpeningRequestsDirection().list());

	public static USE1 = new RuleRegion('USE1', 4, new PortOpeningRequestsDirection().list());

	public static ASST = new RuleRegion('ASST', 5, new PortOpeningRequestsDirection().list());

	public static ASEA = new RuleRegion('ASEA', 6, [PortOpeningRequestsDirection.SubscriptionToOnPrem]);

	public static CNN3 = new RuleRegion('CNN3', 7, new PortOpeningRequestsDirection().list());

	public static WW = new RuleRegion('WW', 8, [PortOpeningRequestsDirection.SubscriptionToInternet]);

	public listByDirection = (
		porDirection: PortOpeningRequestsDirection,
		validNetworks: VirtualNetwork[],
	) : RuleRegion[] => {
		const vNetDictionary = {
			'America': 'America',
			'EAME': 'EAME',
			'AP': 'AP',
			'USSC': 'southcentralus',
			'USE1': 'eastus',
			'ASST': 'southeastasia',
			'ASEA': 'eastasia',
			'CNN3': 'chinanorth3',
			'WW': 'WW',
		};
		const temp = this.list().filter(region => {
			return validNetworks.find(vnet => {
				return vNetDictionary[region.name]?.toLowerCase() == vnet.location?.toLowerCase();
			});
		});
		return (temp.filter(region => region.porDirections.includes(porDirection)));
	};
}